export default __webpack_public_path__ + "static/media/lds-logo_cs.c640ff41f1293949.svg";